import endpointUrls from 'global/Constants/endpointUrls';
import { customerFinancialInfo } from 'global/Models/customerModel';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { setCustomerFinancialInfo } from 'redux/reducer/user/userReducer';
import { AppDispatch, AppThunk } from 'redux/store';

export const getCustomerFinancialInfo = (): AppThunk => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.customerFinancialInfo, {})
    .then((res: IBackendGetGeneric<customerFinancialInfo>) =>
      handleApiThenGeneric<IBackendGetGeneric<customerFinancialInfo>, customerFinancialInfo>({
        res,
        notifFail: false,
        notifSuccess: false,
        onSuccessData: (data: customerFinancialInfo) => dispatch(setCustomerFinancialInfo(data)),
      })
    )
    .catch(() => {});
};
